export const actividadTokenERC20 = [
    {
      title: "Actividad: Crea el token ERC20 para tu propio proyecto",
      value: `
  **Instrucciones:**
  
  1. **Elige un negocio o proyecto real o imaginario.**  
     Por ejemplo: una tienda de ropa, una aplicación de recompensas, un club deportivo, un festival, una cafetería, una plataforma de educación, etc.
  
  2. **Describe brevemente tu proyecto.**  
     Explica en 2-3 frases de qué trata y cuál es su objetivo.
  
  3. **Vas a crear un token ERC20**  
     Recuerda: el estándar ERC20 es para **tokens fungibles**, es decir, cada unidad es igual a otra (como una moneda, punto o acción).
  
  4. **Justifica para qué servirá tu token ERC20 en tu proyecto.**  
     Ejemplo: para recompensar a los clientes más fieles, para realizar votaciones internas, para usarse como moneda de acceso o para representar participaciones.
  
  5. **Completa la parte técnica de tu contrato ERC20:**  
     - **Nombre del token:**  
     - **Símbolo (abreviatura):**  
     - **Cantidad total de tokens (supply):**  
     - **Número de decimales (normalmente 18):**  
     - **Dirección del propietario inicial (puede ser la tuya de MetaMask):**  
     - **Comentario especial (opcional):**
  
  6. **Entrega tu actividad:**  
     Puedes responder en un documento, formulario o enviar la información por la plataforma del curso.
  
  ---
  
  **Ejemplo:**
  
  - **Proyecto:** Plataforma de puntos para clientes frecuentes en una cafetería.
  - **Justificación:** Cada compra otorga puntos canjeables por bebidas gratis y descuentos, los puntos se transfieren entre clientes.
  - **Parte técnica:**
    - **Nombre del token:** CoffeePoints
    - **Símbolo:** COFF
    - **Supply:** 100,000
    - **Decimales:** 2
    - **Dirección inicial:** 0x456...def
    - **Comentario especial:** Los puntos vencen cada fin de año.
  
  ---
  
  **Recuerda:**  
  En esta actividad, **el estándar a usar es siempre ERC20** (token fungible), para que practiques la estructura más utilizada en la economía blockchain.
  
  ¡Piensa en la utilidad, personaliza tu contrato y prepárate para el despliegue!
  `
    }
  ];
  
  export default actividadTokenERC20;
  